import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import ToolCallInlineRow from './shared/ToolCallInlineRow';
import { getDefaultExpandedSections } from './tool-card-config';
import { useToolCardModel } from './tool-card-model';
import { getToolCardRenderer } from './tool-card-registry';
export const ToolCallCard = ({ message }) => {
    var _a, _b;
    const model = useToolCardModel(message);
    const modelStatus = model === null || model === void 0 ? void 0 : model.status;
    const [isExpanded, setIsExpanded] = useState((_a = model === null || model === void 0 ? void 0 : model.defaultExpanded) !== null && _a !== void 0 ? _a : false);
    const [expandedSections, setExpandedSections] = useState((_b = model === null || model === void 0 ? void 0 : model.defaultExpandedSections) !== null && _b !== void 0 ? _b : ['arguments']);
    useEffect(() => {
        if (modelStatus) {
            setExpandedSections(getDefaultExpandedSections(modelStatus));
        }
    }, [modelStatus]);
    if (!model) {
        console.warn('[ToolCallCard] Tool not found for message:', message.id);
        return null;
    }
    const toggleExpanded = model.isExpandable
        ? () => setIsExpanded((value) => !value)
        : undefined;
    const Renderer = getToolCardRenderer(model.displayVariant);
    return (_jsxs(_Fragment, { children: [_jsx(ToolCallInlineRow, { model: model, isExpanded: isExpanded, onToggle: toggleExpanded }), isExpanded && model.isExpandable && (_jsx(Renderer, { model: model, expandedSections: expandedSections, setExpandedSections: setExpandedSections }))] }));
};
export default ToolCallCard;
